import {connect} from "react-redux";
import TollCreate from "./Save";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {saveToll, tollById} from "../../../../service/FasttagToll/action";
import {locationState} from "../../../../service/locations/action";
import {getCityByStateId} from "../../../../service/Account/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    saveTollDetails:state.FasttagToll.saveToll,
    tollView:state.FasttagToll.tollView,
    geoCity:state.Dropdown.geoCity,
    state: state.locationReducer.state,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            saveToll,
            getCityByStateId,
            locationState,
            tollById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TollCreate);
